import React from 'react';
import { useTheme, ITheme } from 'src/theme';
import DownloadIcon from '@assets/icon/download.svg';
import ContainerBlock from '@components/ContainerBlock';
import Heading from '@components/Heading';
import Link from '@components/Link';
import { saveAs } from 'file-saver';
import axios from '@api/index';

export interface PolicyDocumentProps {
  theme?: ITheme;
  margin: string | number;
  url: string;
}

const downloadProductSummary = (url: any) => {
  console.log('summary full path', window.location.origin + window.location.pathname.replace('/index.html', '') + url.replace('./', '/'));
  const fullPath = window.location.origin + window.location.pathname.replace('/index.html', '') + url.replace('./', '/');
  console.log('fullPath', fullPath);
  axios({
    url: fullPath,
    method: 'GET',
    headers: {
      'Access-Control-Allow-Origin': '*',
    },
    responseType: 'blob', // important
  }).then((response) => {
    let extension = 'pdf';
    let tempFileName = `Plan_Summary`
    let fileName = `${tempFileName}.${extension}`;
    var blob = new Blob([response.data as unknown as BlobPart], { type: "application/pdf" });
    saveAs(blob, fileName);
  });
  return false;
}

function PolicyDocument({ margin, url }: PolicyDocumentProps) {
  const theme = useTheme();
  return (
    <ContainerBlock
      borderTop={`3px solid ${theme.colors.primary}`}
      boxShadow="0 2px 2px 0 rgba(204, 204, 204, 0.5)"
      background={theme.colors.grey[200]}
      padding={20}
      paddingTablet="20px 30px"
      margin={margin}
    >
      <Heading margin="0 0 20px" color={theme.colors.grey[400]} variant="smallTitle" fontWeight={600}>Policy Documents</Heading>
      <Link icon={DownloadIcon} text="Plan summary" hasDownload={true} downloadCallback={() => { downloadProductSummary(url); }} slotIcon="start" target="_blank" rel="noopener noreferrer" url={url} /><br/><br/>
      <Link icon={DownloadIcon} download={'Product-Summary.pdf'} text="Product summary" slotIcon="start" target="_blank" rel="noopener noreferrer" url={'./docs/mltc/Product-Summary.pdf'} /><br /><br />
      <Link icon={DownloadIcon} text="Policy contract" download='Policy-Contract.pdf' slotIcon="start" target="_blank" rel="noopener noreferrer" url={'./docs/mltc/Policy-Contract.pdf'} />
    </ContainerBlock>
  );
};

PolicyDocument.defaultProps = {
  margin: "0 0 30px",
  url: ''
}

export default PolicyDocument;
